import { useAgent } from '@copilotkit/react-core/v2'
import { useEffect, useRef, useState } from 'react'

export function useAgentConnection() {
  const { agent } = useAgent()
  const [isConnecting, setIsConnecting] = useState(true)
  const wasRunningRef = useRef(false)

  useEffect(() => {
    if (!isConnecting) return
    if (agent.isRunning) {
      wasRunningRef.current = true
    } else if (wasRunningRef.current) {
      setIsConnecting(false)
    }
  }, [agent.isRunning, isConnecting])

  function resetConnection() {
    wasRunningRef.current = false
    setIsConnecting(true)
  }

  return { isConnecting, resetConnection }
}
